import { MessageModel } from "../schema/message.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class MessageContainer extends MongoBaseContainer{
    message: MessageModel
}